<template>
  <router-view></router-view>
</template>

<script>
import { getSelectedDeviceToken, getUserToken } from "@/storage/memoryStorage";

export default {
  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    isConnected() {
      return this.$store.getters.isConnected;
    }
  },

  methods: {
    handleUnsubscribe(deviceMAC = "", macList = []) {
      let WSUnSubscribe = {
        data: false
      };

      if (macList.length) {
        WSUnSubscribe.userToken = getUserToken();
        WSUnSubscribe.macList = macList;
      } else {
        WSUnSubscribe.deviceToken = getSelectedDeviceToken(deviceMAC);
        if( WSUnSubscribe.deviceToken === null)
        return;//message without token will caouse ws to disconnect
      }

      this.$socket.send(JSON.stringify(WSUnSubscribe));
    },

    handleSubscribe(deviceMAC = "", macList = []) {
      let WSSubscribe = {
        data: true
      };

      if (macList.length) {
        WSSubscribe.userToken = getUserToken();
        WSSubscribe.macList = macList;
      } else {
        WSSubscribe.deviceToken = getSelectedDeviceToken(deviceMAC);
        if( WSSubscribe.deviceToken === null)
        return;//message without token will cause ws to disconnect
      }

      this.$socket.send(JSON.stringify(WSSubscribe));
    }
  },

  watch: {
    selectedDevice: function(newDevice, oldDevice) {
      if ((newDevice.mac !== oldDevice.mac) || (!oldDevice.macList || !newDevice.macList)) {

      if (oldDevice.macList) {
        this.handleUnsubscribe(null, oldDevice.macList);
      } else {
        this.handleUnsubscribe(oldDevice.mac);
      }

      if (newDevice.macList) {
        this.handleSubscribe(null, newDevice.macList);
      } else {
        this.handleSubscribe(newDevice.mac);
      }

      }
    },

    isConnected: function(newStatus, oldStatus) {
      if (newStatus) {
        if (this.selectedDevice.macList) {
          this.handleSubscribe(null, this.selectedDevice.macList);
        } else {
          this.handleSubscribe(this.selectedDevice.mac);
        }
      }
    }
  },

  mounted() {
    if (this.isConnected) {
      if (this.selectedDevice.macList) {
        this.handleSubscribe(null, this.selectedDevice.macList);
      } else {
        this.handleSubscribe(this.selectedDevice.mac);
      }
    }
  },

  beforeDestroy() {
    try {
      if (this.selectedDevice.macList) {
        this.handleUnsubscribe(null, this.selectedDevice.macList);
      } else {
        this.handleUnsubscribe(this.selectedDevice.mac);
      }
    } catch (err) {
      //console.log("Unable send unsubscribe from live data");
    }
  }
};
</script>
